/*  MUI  */
import { Paper } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { AdminVendorIncidentsTable } from './internal/AdminVendorIncidentsTable';

export const AdminVendorIncidents = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('Common.vendor_incidents')} />
            <Paper elevation={0} variant="outlined">
                <AdminVendorIncidentsTable />
            </Paper>
        </>
    );
};
